<template>
  {{ $route.params.id }}
  <div>{{ 상품권 }}</div>
</template>

<script>
export default {
    name:'coupon-v',

    data(){
      return{
        상품권:'',
        라우트:''
      }
    },

    mounted() {
      this.라우트=this.$route.params.id
      console.log(this.$route.params.id)

    },
}
</script>

<style>

</style>